import React from "react";

export default function C_V_TEXTAREA({ value }) {
  if (!value) return null;

  return (
    <span
      title={value} // Hovering shows the full text natively
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        padding: "0 8px",
        boxSizing: "border-box",
      }}
    >
      {value}
    </span>
  );
}
